export const isMessageRole = (message, type) => {
  return (message == null ? void 0 : message.role) === type;
};
export const isUserMessage = message => {
  return isMessageRole(message, 'user');
};
export const isAssistantMessage = message => {
  return isMessageRole(message, 'assistant');
};
//# sourceMappingURL=messageUtils.js.map